import { render } from "./xtx-city.vue?vue&type=template&id=29c2cd1e&scoped=true"
import script from "./xtx-city.vue?vue&type=script&lang=js"
export * from "./xtx-city.vue?vue&type=script&lang=js"

import "./xtx-city.vue?vue&type=style&index=0&id=29c2cd1e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c2cd1e"]])

export default __exports__